import dayjs from "dayjs";
import axiosInstance from "../config/axios-config";
import { toast } from "react-toastify";
import { AxiosError } from "axios";
import axiosInstanceV2 from "../config/axios-v2-config";

const BASE_DRUG_CATEGORY_URL = "/v1/categories";
const BASE_DRUG_CATEGORY_URL_V2 = "/v2/categories";
export const updateCategoryName = async ({
  id,
  name,
}: {
  id: string;
  name: string;
}) => {
  try {
    const response = await axiosInstanceV2.patch(
      `${BASE_DRUG_CATEGORY_URL_V2}/${id}`,
      {
        name: name,
      }
    );
    if (response.status !== 200) {
      toast.error("Unable to update category data");
      throw Error("Unable to update category data");
    } else {
      return response.data;
    }
  } catch (error) {
    console.log(error);
    toast.error("Unable to update category data");
    throw Error("Unable to update category data");
  }
};

export const getCategoryNames = async ({
  startTime = dayjs().format("DD/MM/YYYY HH:mm:ss").toString(),
  endtime = dayjs()
    .subtract(1, "year")
    .format("DD/MM/YYYY HH:mm:ss")
    .toString(),
  count = 10,
}: {
  startTime: string;
  endtime: string;
  count: number;
}) => {
  try {
    const response = await axiosInstanceV2.get(BASE_DRUG_CATEGORY_URL_V2, {
      // params: { startTimeframe: startTime, endTimeframe: endtime, n: count },
    });
    if (response.status !== 200) {
      throw Error("Unable retrieve category data");
    } else {
      return response.data;
    }
  } catch (error) {
    console.log(error);
    throw Error("Unable retrieve category data");
  }
};

export const addNewCategoryName = async (categoryName: string) => {
  try {
    const response = await axiosInstanceV2.post(BASE_DRUG_CATEGORY_URL_V2, {
      name: categoryName,
    });
    if (response.status !== 201) {
      toast.error("Unable save category data");
      throw Error("Unable save category data");
    } else {
      return response.data;
    }
  } catch (error) {
    if (error instanceof AxiosError) {
      if (error.response?.status === 409) {
        const alreadyExists = error.response?.data.message;
        toast.error(alreadyExists);
        throw Error(alreadyExists);
      }
    } else {
      toast.error("Unexpected error saving category");
      throw Error("Unexpected error saving category");
    }
  }
};
export const getCategoriesWithGenericsAndBrands = async () => {
  try {
    const response = await axiosInstanceV2.get(
      `${BASE_DRUG_CATEGORY_URL_V2}/with-generics-and-brands`
    );
    if (response.status !== 200) {
      throw Error("Unable to fetch categories with generics and brands");
    } else {
      return response.data;
    }
  } catch (error) {
    throw Error("Unable to fetch categories with generics and brands");
  }
};

export const deleteCategoryById = async (id: string) => {
  try {
    const response = await axiosInstanceV2.delete(
      `${BASE_DRUG_CATEGORY_URL_V2}/${id}`
    );
    if (response.status !== 204) {
      toast.error("Unable to delete category");
      throw Error("Unable to delete category");
    } else {
      return response.data;
    }
  } catch (error) {
    console.log(error);
    toast.error("Unable to delete category");
    throw Error("Unable to delete category");
  }
};
